export default {
  init() {
    // JavaScript to be fired on all pages
	const nav_burger = document.querySelector('.nav-burger');
	const header_nav = document.querySelector('.header-nav');
	nav_burger.addEventListener('click',(event) => {
		nav_burger.classList.toggle('open');
		header_nav.classList.toggle('open-nav');

		$('body').toggleClass('hide-scroll');
	});

	$(document).ready(function(){
		if($(window).width() < 576) {
			$(window).scroll(function() {

			let elementsArr = $('.specialists-item');

			elementsArr.each(function() {
					let wt = $(window).scrollTop();
					let wh = $(window).height();
					let et = $(this).offset().top;
					let eh = $(this).outerHeight();
					let dh = $(document).height();
					// if (wt + wh >= et || wh + wt == dh || eh + et < wh){
						if(wt + wh - et > 350  && wt + wh - et < 800) {
							$(this).addClass('specialists-mobile-show');
						} else {
							$(this).removeClass('specialists-mobile-show');
						}
					// }

			  });
			});
		}

		// Language menu
		$('.menu-item-has-children.active-language > a').on('click', function() {
		  event.preventDefault();
      $(this).parent().toggleClass('active');
      $(this).parent().find('.sub-menu').toggleClass('active');
		});
    if($(window).width() <= '992') {
      $('.header').addClass('header-scroll');
      $('.header-nav .menu-item-has-children').append('<div class="menu-item-row"><div class="menu-item-row-item"></div></div>');

      $('.header-nav .menu-item-has-children .menu-item-row').on('click', function() {
        $(this).toggleClass('active');
        $(this).parent().find('.sub-menu').toggleClass('active');
      });
    }

		//Owl team
		$(".team-slider").owlCarousel({
			loop: false,
			margin: 30,
			dots: true,

			responsive: {
			0: {
				items: 1,
			},
			320: {
				items: 2,
			},
			576: {
				items: 3,
			},
			992: {
				items: 4,
			}
			}
		});
		$(".team-slider-service").owlCarousel({
			loop: false,
			margin: 30,
			dots: true,

			responsive: {
			0: {
				items: 1,
			},
			320: {
				items: 2,
			},
			576: {
				items: 3,
			},
			992: {
				items: 3,
			}
			}
		});

		if($(window).width() < '992') {
			$('.nav-langs').appendTo('.nav-inform-mobile');
			// $('.nav-schedule').appendTo('.nav-inform-mobile');
		}
	})


	$(document).ready(function() {
		//transfer data to value of input:submit
		var btn_value_contact = $('#contact-page-form').attr('data-btn-text-contact');
		$("#contact-page-form input[type='submit']").val(btn_value_contact);

		var btn_value_sign_up = $('.popup-sign-up').attr('data-btn-text-sign-up');
		$(".popup-sign-up input[type='submit']").val(btn_value_sign_up);

		// var btn_value_registration = $('.popup-registration').attr('data-btn-text-registration');
		// $(".popup-registration input[type='submit']").val(btn_value_registration);



		//show pop-up "sign-up"
		$('.sign-up-btn').on('click', function () {
			$('.popup-sign-up').addClass('show-popup-sign-up');
		});

		$('.sign-up-btn').on('click', function () {
			$('.popup-sign-up').addClass('show-popup-sign-up');
		});

		$('.price-post-btn').on('click', function () {
			$('.popup-sign-up').addClass('show-popup-sign-up');
		});

		$('.procedure-sign-up-btn').on('click', function () {
			$('.popup-sign-up').addClass('show-popup-sign-up');
		});

		$('.diagnostic-service-btn-sign-up').on('click', function () {
			$('.popup-sign-up').addClass('show-popup-sign-up');
		});

		$('.ic-service-btn').on('click', function () {
			$('.popup-sign-up').addClass('show-popup-sign-up');
		});

		//show pop-up "consultation"
		$('.consultation-btn').on('click', function () {
			$('.popup-consultation').addClass('show-popup-consultation');
		});

		$('.diagnostic-service-btn-ask').on('click', function () {
			$('.popup-consultation').addClass('show-popup-consultation');
		});



		//show pop-up "registration"
		$('.event-btn').on('click', function () {
			$('.popup-registration').addClass('show-popup-registration');
		});



		//hide pop-up "sign-up"
		$('.popup-sign-up-closer').on('click', function () {
			$('.popup-sign-up').removeClass('show-popup-sign-up');

			// Clear form
			$('.wpcf7-form').find('input').not(':input[type=submit]').val('');
			$('.wpcf7-not-valid-tip').remove();
			$('.wpcf7-response-output').remove();
		});

		$(document).mouseup(function (e){
			if ($('.popup-sign-up').hasClass('show-popup-sign-up')) {
				var div = $(".popup-sign-up-wrap");
				if (!div.is(e.target) && div.has(e.target).length === 0 ) {
					$(".popup-sign-up").removeClass('show-popup-sign-up');

					// Clear form
					$('.wpcf7-form').find('input').not(':input[type=submit]').val('');
					$('.wpcf7-not-valid-tip').remove();
					$('.wpcf7-response-output').remove();
				}
			}
		});



		//hide pop-up "consultation"
		$('.popup-consultation-closer').on('click', function () {
			$('.popup-consultation').removeClass('show-popup-consultation');

			// Clear form
			$('.wpcf7-form').find('input').not(':input[type=submit]').val('');
			$('.wpcf7-not-valid-tip').remove();
			$('.wpcf7-response-output').remove();
		});

		$(document).mouseup(function (e){
			if ($('.popup-consultation').hasClass('show-popup-consultation')) {
				var div = $(".popup-consultation-wrap");
				if (!div.is(e.target) && div.has(e.target).length === 0 ) {
					$(".popup-consultation").removeClass('show-popup-consultation');

					// Clear form
					$('.wpcf7-form').find('input').not(':input[type=submit]').val('');
					$('.wpcf7-not-valid-tip').remove();
					$('.wpcf7-response-output').remove();
				}
			}
		});



		//hide pop-up "registration"
		$('.popup-registration-closer').on('click', function () {
			$('.popup-registration').removeClass('show-popup-registration');

			// Clear form
			$('.wpcf7-form').find('input').not(':input[type=submit]').val('');
			$('.wpcf7-not-valid-tip').remove();
			$('.wpcf7-response-output').remove();
		});

		$(document).mouseup(function (e){
			if ($('.popup-registration').hasClass('show-popup-registration')) {
				var div = $(".popup-registration-wrap");
				if (!div.is(e.target) && div.has(e.target).length === 0 ) {
					$(".popup-registration").removeClass('show-popup-registration');

					// Clear form
					$('.wpcf7-form').find('input').not(':input[type=submit]').val('');
					$('.wpcf7-not-valid-tip').remove();
					$('.wpcf7-response-output').remove();
				}
			}
		});



		// margin-left in single-event-page(event-author)
		// let widthToLogo = $('.header-inner').offset().left;
		// $('.event-author').css({ "margin-left": widthToLogo });



		// add dynamic info to popup "registration"
		if($('*').is('.info-name') || $('*').is('.info-cost')) {
			$('.popup-event-name').attr('placeholder', $('.info-name').html().trim());
			$('.popup-event-name').attr('value', $('.info-name').html().trim());

			$('.popup-event-cost').attr('placeholder', $('.info-cost').html().trim());
			$('.popup-event-cost').attr('value', $('.info-cost').html().trim());
		} else {
			// console.log('undefined');
		};

		//scale certificate after click on it
		const imagesScale = document.querySelectorAll('.certificate-images');
		const imagesScaleWrapper = document.querySelector('.scale-background');

		for(let imageScale of imagesScale) {
			imageScale.addEventListener('click', () => {
				imageScale.classList.toggle('certificate-images-scale');
				imagesScaleWrapper.classList.toggle('certificate-images-scale');
			});

			imagesScaleWrapper.addEventListener('click', () => {
				imagesScaleWrapper.classList.remove('certificate-images-scale');
				imageScale.classList.remove('certificate-images-scale');
			});
		}
	});

	document.addEventListener( 'wpcf7mailsent', function( event ) {
		window.dataLayer.push({'event': 'formsend_zapis'});
	});
	// document.addEventListener( 'wpcf7mailsent', function( event ) {
	// 	window.dataLayer.push({
	// 	"event" : "formsend_zapis",
	// 	"formId" : event.detail.contactFormId,
	// 	"response" : event.detail.inputs
	// 	})
	// });


	$('.show-phones').on('click', function() {
		$('.phones-mobile').toggleClass('open-phones');
	})
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
